import { Injectable } from '@angular/core'
import { SvgIconNames } from '../../shared/models/interfaces'
import { ToastConfig, ToastOptions } from '../../shared/models/toast.interfaces'

@Injectable({ providedIn: 'root' })
export class ToastService {
    toasts: ToastConfig[] = []

    saveSuccess(): void {
        this.showSuccess('toast.saveSuccess')
    }

    showSuccess(text: string, icon?: SvgIconNames): void {
        this.show(text, { classname: 'bg-success text-light', delay: 5000, icon })
    }

    showWarning(text: string, icon?: SvgIconNames): void {
        this.show(text, { classname: 'bg-warning text-light', delay: 5000, icon })
    }

    showInfo(text: string, icon?: SvgIconNames): void {
        this.show(text, { classname: 'background-secondary text-light', delay: 5000, icon })
    }

    showError(text: string, icon?: SvgIconNames): void {
        this.show(text, { classname: 'background-primary text-light', delay: 5000, icon })
    }

    remove(toast: ToastConfig): void {
        this.toasts = this.toasts.filter((t) => t !== toast)
    }

    private show(text: string, options: ToastOptions = {} as ToastOptions): void {
        this.toasts.push({ text, ...options })
    }
}
